import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { getProfile } from '@lib/api';
import UserNameSection from '@components/profile/UserNameSection';
import AuthSection from '@components/profile/AuthSection';
import { useQuery } from '@tanstack/react-query';
import { Loading } from '@components/atomic/atoms';

const Profile = () => {
	const { data: profileFromApi, isPending } = useQuery({
		queryKey: ['profile'],
		queryFn: () => getProfile(),
	});
	return (
		<div id="profile" className="megaContent">
			{isPending ? (
				<Loading />
			) : (
				<div className="container-fluid">
					<Row className="flex-wrap justify-content-around" style={{ columnGap: '1%' }}>
						<Col>
							<UserNameSection profileFromApi={profileFromApi.data} />
							<div className={`simple-box scenarita custom-simple_box`}>
								<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									<div style={{ display: 'grid', gap: '8px' }}>
										<h3
											style={{
												fontSize: '18px',
												fontWeight: 700,
												lineHeight: '28px',
												marginBottom: 0,
											}}
										>
											E-mail
										</h3>

										<p
											style={{
												lineHeight: '28px',
												marginBottom: 0,
											}}
										>
											{profileFromApi.data.email}
										</p>
									</div>
									<Button
										href="mailto:support.openrep@openeconomics.eu"
										style={{
											border: 'none',
											backgroundColor: 'transparent',
											color: '#06797F',
											fontWeight: 500,
											textTransform: 'none',
										}}
									>
										per modificare l'e-mail contatta l'assistenza
									</Button>
								</div>
							</div>
						</Col>
					</Row>
					<Row className="flex-wrap justify-content-around" style={{ columnGap: '1%' }}>
						<Col>
							<AuthSection profileFromApi={profileFromApi.data} />
						</Col>
					</Row>
				</div>
			)}
		</div>
	);
};

export default Profile;
